import { assertNever } from "@impero-com/common/utils/obj";

import type {
    ControlPolicies,
    ControlPolicy,
    UpdatableControlPolicies,
} from "api/generated/model";

export type ControlPolicyKind = keyof ControlPolicies;

export type ControlPolicyOption = "off" | "on" | "enforced";

export const CONTROL_POLICY_OPTIONS: readonly ControlPolicyOption[] = [
    "off",
    "on",
    "enforced",
];

export function optionOf(policy: ControlPolicy): ControlPolicyOption {
    switch (policy.mode) {
        case "Default":
            return policy.value ? "on" : "off";
        case "Enforced":
            return "enforced";
        default:
            return assertNever(policy);
    }
}

export function policyOf(option: ControlPolicyOption): ControlPolicy {
    switch (option) {
        case "off":
            return { mode: "Default", value: false };
        case "on":
            return { mode: "Default", value: true };
        case "enforced":
            return { mode: "Enforced" };
        default:
            return assertNever(option);
    }
}

export function updateOf(
    kind: ControlPolicyKind,
    option: ControlPolicyOption
): UpdatableControlPolicies {
    switch (kind) {
        case "loginProtection":
            return { loginProtection: policyOf(option) };
        case "segregationOfDuties":
            return { segregationOfDuties: policyOf(option) };
        default:
            return assertNever(kind);
    }
}

export function enforcementChange(
    saved: ControlPolicyOption,
    selected: ControlPolicyOption
): "enforce" | "unlock" | null {
    if (saved !== "enforced" && selected === "enforced") {
        return "enforce";
    }
    if (saved === "enforced" && selected !== "enforced") {
        return "unlock";
    }
    return null;
}
